import { render } from "./NotificationsPage.vue?vue&type=template&id=ba97cb52&scoped=true&ts=true"
import script from "./NotificationsPage.ts?vue&type=script&lang=ts"
export * from "./NotificationsPage.ts?vue&type=script&lang=ts"

import "./NotificationsPage.vue?vue&type=style&index=0&id=ba97cb52&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba97cb52"]])

export default __exports__